/*
 * @Description: 新油卡接口api
 * @Author: shiao
 * @Date: 2022-02-24 11:44:48
 * @LastEditors: lizhenglin
 * @LastEditTime: 2022-10-09 17:34:23
 */
import http from "@/providers/http";
// 通过支付类型，支付金额获取可用红包
export const getThirdrechargeOilCoinInfo = (params = {}) => {
  return http.post("/coin/member/appCoin/reserveCoinAmount", params);
};
// 获取会员积分
export const getAppCreditsInfo = (params = {}) => {
  return http.post("coin/member/appCredits/info", params);
};
// 获取会员红包
export const getAppCoinInfo = (params = {}) => {
  return http.post("coin/member/appCoin/info", params);
};
//获取协议信息
export const getAgreementDetails = (params = {}) => {
  return http.get("/cms-v2/index/agreement/app/detail", params);
};
// 订单创建
export const memberOrderCreate = (params = {}) => {
  return http.post("order/member/order/create", params);
};
// 获取绑定油卡列表
export const getThirdrechargeOilBindList = (params = {}) => {
  return http.post("/thirdrecharge/member/oil/bind/list", params);
};
// 绑定油卡
export const bindThirdrechargeOilCard = (params = {}) => {
  return http.post("/thirdrecharge/member/oil/card/bind", params);
};
// 编辑油卡备注
export const makeThirdrechargeOilCardRemark = (params = {}) => {
  return http.post("/thirdrecharge/member/oil/card/make/remark", params);
};
// 编辑油卡备注
export const deleteThirdrechargeOilCard = (params = {}) => {
  return http.post("/thirdrecharge/member/oil/card/delete", params);
};
// 获取面额列表
export const getThirdrechargeOilDenominationList = (params = {}) => {
  return http.post(
    "/thirdrecharge/member/recharge/oil/denomination/list",
    params
  );
};
// 油卡确认订单
export const getThirdrechargeOilOrderConfirm = (params = {}) => {
  return http.post("/order/member/order/confirm", params);
};
// 获取油卡服务费比例
export const getThirdrechargeOilCardService = (params = {}) => {
  return http.post("/thirdrecharge/member/oil/card/service/charge", params);
};
// 手动获取积分
export const getThirdrechargeOilCredits = (params = {}) => {
  return http.post("/thirdrecharge/member/oil/get/credits", params);
};
// 获取油卡订单详情
export const getThirdrechargeOilOrderDetail = (params = {}) => {
  return http.post("/thirdrecharge/member/oil/order/detail", params);
};
// 获取前端展示状态
export const getThirdrechargeOilDisplayStatus = (params = {}) => {
  return http.post("/thirdrecharge/member/oil/get/display/status", params);
};
// 获取配置说明
export const getThirdrechargeOilChargeDescription = (params = {}) => {
  return http.post("/thirdrecharge/member/oil/get/charge/description", params);
};
// 通过item_id获取价格
export const getThirdrechargeOilCardPrice = (params = {}) => {
    return http.post('/thirdrecharge/member/oil/card/get/price', params)
}
// 检测该用户是否填写身份证信息
export const checkThirdrechargeMemberCardInfo = (params = {}) => {
    return http.post('/thirdrecharge/member/check/id/card/info', params)
} 
// 修复以前未填写身份证号码的油卡用户信息
export const fixThirdrechargeMemberCardInfo = (params = {}) => {
    return http.post('/thirdrecharge/member/fix/id/card/info', params)
} 
